// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Side Navigation Styles */
.sidebar-transition {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Mobile responsive adjustments */
@media (max-width: 1279px) {
  .sidebar-desktop {
    transform: translateX(-100%);
  }
  
  .sidebar-mobile-open {
    transform: translateX(0);
  }
}

/* Desktop responsive adjustments */
@media (min-width: 1280px) {
  .sidebar-desktop {
    transform: translateX(0);
  }
  
  .desktop-only {
    display: flex !important;
  }
  
  .main-content {
    transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .main-content-collapsed {
    margin-left: 80px;
  }
  
  .main-content-expanded {
    margin-left: 280px;
  }
}

/* Hide desktop-only elements on mobile/tablet */
@media (max-width: 1279px) {
  .desktop-only {
    display: none !important;
  }
  
  .mobile-menu-btn {
    display: block !important;
  }
  
  .desktop-padding {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

/* Show mobile menu button on mobile/tablet, hide on desktop */
@media (min-width: 1280px) {
  .mobile-menu-btn {
    display: none !important;
  }
  
  .desktop-padding {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

/* Main content area transitions */
.main-content-area {
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Mobile content - no margin */
@media (max-width: 1279px) {
  .main-content-area {
    margin-left: 0 !important;
  }
}

/* Page content adjustments */
.page-content {
  width: 100%;
  min-height: calc(100vh - 80px); /* Account for top bar */
  overflow-x: hidden;
}

/* Ensure pages don't get cut off */
.main-content main {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

/* Page container responsive behavior */
.page-container {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

/* Responsive padding adjustments */
@media (max-width: 640px) {
  .page-container {
    padding: 1rem;
  }
}

@media (min-width: 641px) and (max-width: 1279px) {
  .page-container {
    padding: 1.5rem;
  }
}

@media (min-width: 1280px) {
  .page-container {
    padding: 2rem;
  }
}

/* Ensure content doesn't overflow on small screens */
@media (max-width: 1279px) {
  .main-content-area {
    width: 100vw;
    max-width: 100vw;
    overflow-x: hidden;
  }
}

/* Force responsive behavior for all containers */
* {
  box-sizing: border-box;
}

/* Ensure no horizontal overflow */
body, html {
  overflow-x: hidden;
}

/* Responsive text and spacing */
@media (max-width: 640px) {
  .text-responsive {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 641px) and (max-width: 1279px) {
  .text-responsive {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

@media (min-width: 1280px) {
  .text-responsive {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

/* Smooth transitions for all layout changes */
.sidebar-transition,
.main-content-area,
.sidebar-item {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Sidebar hover effects */
.sidebar-item {
  position: relative;
  overflow: hidden;
}

.sidebar-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.sidebar-item:hover::before {
  left: 100%;
}

/* Collapsed sidebar tooltip styles */
.sidebar-tooltip {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 1000;
  margin-left: 8px;
}

.sidebar-tooltip::before {
  content: '';
  position: absolute;
  left: -4px;
  top: 50%;
  transform: translateY(-50%);
  border: 4px solid transparent;
  border-right-color: rgba(0, 0, 0, 0.8);
}

.sidebar-item:hover .sidebar-tooltip {
  opacity: 1;
  visibility: visible;
}

/* Search input focus styles */
.search-input:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  border-color: var(--primary);
}

/* User menu dropdown animations */
.user-menu {
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile overlay */
.mobile-overlay {
  backdrop-filter: blur(2px);
}

/* Smooth transitions for all interactive elements */
button, input, .sidebar-item {
  transition: all 0.2s ease;
}

/* Focus styles for accessibility */
button:focus-visible,
input:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

/* Loading state for navigation */
.navigation-loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Responsive text sizing */
@media (max-width: 640px) {
  .sidebar-text {
    font-size: 14px;
  }
}

@media (min-width: 641px) and (max-width: 1279px) {
  .sidebar-text {
    font-size: 15px;
  }
}

@media (min-width: 1280px) {
  .sidebar-text {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/sidebar.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,iDAAiD;AACnD;;AAEA,kCAAkC;AAClC;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA,kCAAkC;AAClC;EACE,yDAAyD;AAC3D;;AAEA,+BAA+B;AAC/B;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,8BAA8B,EAAE,wBAAwB;EACxD,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,iDAAiD;AACjD;EACE,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA,8CAA8C;AAC9C;;;EAGE,iDAAiD;AACnD;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;AAC5B;;AAEA,oDAAoD;AACpD;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;;EAEE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Side Navigation Styles */\n.sidebar-transition {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Mobile responsive adjustments */\n@media (max-width: 1279px) {\n  .sidebar-desktop {\n    transform: translateX(-100%);\n  }\n  \n  .sidebar-mobile-open {\n    transform: translateX(0);\n  }\n}\n\n/* Desktop responsive adjustments */\n@media (min-width: 1280px) {\n  .sidebar-desktop {\n    transform: translateX(0);\n  }\n  \n  .desktop-only {\n    display: flex !important;\n  }\n  \n  .main-content {\n    transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  \n  .main-content-collapsed {\n    margin-left: 80px;\n  }\n  \n  .main-content-expanded {\n    margin-left: 280px;\n  }\n}\n\n/* Hide desktop-only elements on mobile/tablet */\n@media (max-width: 1279px) {\n  .desktop-only {\n    display: none !important;\n  }\n  \n  .mobile-menu-btn {\n    display: block !important;\n  }\n  \n  .desktop-padding {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n\n/* Show mobile menu button on mobile/tablet, hide on desktop */\n@media (min-width: 1280px) {\n  .mobile-menu-btn {\n    display: none !important;\n  }\n  \n  .desktop-padding {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n}\n\n/* Main content area transitions */\n.main-content-area {\n  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Mobile content - no margin */\n@media (max-width: 1279px) {\n  .main-content-area {\n    margin-left: 0 !important;\n  }\n}\n\n/* Page content adjustments */\n.page-content {\n  width: 100%;\n  min-height: calc(100vh - 80px); /* Account for top bar */\n  overflow-x: hidden;\n}\n\n/* Ensure pages don't get cut off */\n.main-content main {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n/* Page container responsive behavior */\n.page-container {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n/* Responsive padding adjustments */\n@media (max-width: 640px) {\n  .page-container {\n    padding: 1rem;\n  }\n}\n\n@media (min-width: 641px) and (max-width: 1279px) {\n  .page-container {\n    padding: 1.5rem;\n  }\n}\n\n@media (min-width: 1280px) {\n  .page-container {\n    padding: 2rem;\n  }\n}\n\n/* Ensure content doesn't overflow on small screens */\n@media (max-width: 1279px) {\n  .main-content-area {\n    width: 100vw;\n    max-width: 100vw;\n    overflow-x: hidden;\n  }\n}\n\n/* Force responsive behavior for all containers */\n* {\n  box-sizing: border-box;\n}\n\n/* Ensure no horizontal overflow */\nbody, html {\n  overflow-x: hidden;\n}\n\n/* Responsive text and spacing */\n@media (max-width: 640px) {\n  .text-responsive {\n    font-size: 0.875rem;\n    line-height: 1.25rem;\n  }\n}\n\n@media (min-width: 641px) and (max-width: 1279px) {\n  .text-responsive {\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n}\n\n@media (min-width: 1280px) {\n  .text-responsive {\n    font-size: 1.125rem;\n    line-height: 1.75rem;\n  }\n}\n\n/* Smooth transitions for all layout changes */\n.sidebar-transition,\n.main-content-area,\n.sidebar-item {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Sidebar hover effects */\n.sidebar-item {\n  position: relative;\n  overflow: hidden;\n}\n\n.sidebar-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.sidebar-item:hover::before {\n  left: 100%;\n}\n\n/* Collapsed sidebar tooltip styles */\n.sidebar-tooltip {\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.2s ease;\n  z-index: 1000;\n  margin-left: 8px;\n}\n\n.sidebar-tooltip::before {\n  content: '';\n  position: absolute;\n  left: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: 4px solid transparent;\n  border-right-color: rgba(0, 0, 0, 0.8);\n}\n\n.sidebar-item:hover .sidebar-tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Search input focus styles */\n.search-input:focus {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  border-color: var(--primary);\n}\n\n/* User menu dropdown animations */\n.user-menu {\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Mobile overlay */\n.mobile-overlay {\n  backdrop-filter: blur(2px);\n}\n\n/* Smooth transitions for all interactive elements */\nbutton, input, .sidebar-item {\n  transition: all 0.2s ease;\n}\n\n/* Focus styles for accessibility */\nbutton:focus-visible,\ninput:focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n/* Loading state for navigation */\n.navigation-loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* Responsive text sizing */\n@media (max-width: 640px) {\n  .sidebar-text {\n    font-size: 14px;\n  }\n}\n\n@media (min-width: 641px) and (max-width: 1279px) {\n  .sidebar-text {\n    font-size: 15px;\n  }\n}\n\n@media (min-width: 1280px) {\n  .sidebar-text {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
